import React from 'react'
let OpenModalCompra = React.createContext(false);
let SetOpenModalCompra = React.createContext(() => {});

export {
    OpenModalCompra,
    SetOpenModalCompra
}

export default OpenModalCompra;